/* Cost Comparison — assets/cost-comparison.js (jQuery)
   Loads jQuery automatically if the theme doesn't already include it.

   Works like the Stark Future "maintenanceComparison" component:
   - Every bike has cumulative cost data points, one per riding hour (hour 1 … 100),
     calculated at the DEFAULT fuel price.
   - When the visitor changes the fuel price, every hour gets:
         extra = fuelCostPerHour × (newPrice / defaultPrice) − fuelCostPerHour
     so point[i] = point[i] + extra × (i + 1)
   - Riding hours are limited to 1 … number of data points (100).
   - The totals are point[hours − 1], rounded, and shown as <strong>$6,926.00</strong>.
   - The chart always shows all hours (1 … 100), with smooth lines (tension 0.4).

   If a bike has no data points, a simple fallback model is used:
     cost(h) = h × (litres/hour × fuel price + other/hour) + maintenance "every N hours: cost"
*/
(function () {
  function init($) {
    var SVGNS = 'http://www.w3.org/2000/svg';

    function el(tag, attrs) {
      var n = document.createElementNS(SVGNS, tag);
      for (var k in attrs) n.setAttribute(k, attrs[k]);
      return n;
    }

    function num(v) {
      if (typeof v === 'number') return v;
      var n = parseFloat(String(v == null ? '' : v).replace(',', '.').replace(/[^\d.\-]/g, ''));
      return isNaN(n) ? 0 : n;
    }

    function parsePoints(text) {
      var list = String(text || '').split(/[\s,;]+/).filter(Boolean).map(num);
      return list.length ? list : null;
    }

    function parseSchedule(text) {
      return String(text || '').split(/\n|;/).map(function (line) {
        var m = line.match(/(\d+(?:[.,]\d+)?)\D+?(\d+(?:[.,]\d+)?)/);
        return m ? { every: num(m[1]), cost: num(m[2]) } : null;
      }).filter(function (x) { return x && x.every > 0; });
    }

    // Same as Stark: 16485 → "16k", 820 → "820"
    function kLabel(v) { return v >= 1000 ? Math.floor(v / 1000) + 'k' : String(Math.floor(v)); }

    // Built-in example data (Stark VARG / 450 4-stroke / 250 2-stroke, 100 hours, default fuel 1.96).
    // Used by position (1st, 2nd, 3rd bike) when a bike block has no data points and
    // "Use built-in example data" is on in the section settings.
    var BUILTIN = [{"points":[2.75,5.5,8.25,11.0,13.76,16.51,19.26,22.01,24.76,27.51,30.26,33.01,35.76,38.52,41.27,44.02,46.77,49.52,52.27,55.02,57.77,60.52,63.28,66.03,68.78,71.53,74.28,77.03,79.78,82.53,85.28,88.03,90.79,93.54,96.29,99.04,101.79,104.54,107.29,281.99,284.74,287.49,290.24,292.99,295.74,298.49,301.24,304.0,306.75,309.5,312.25,315.0,317.75,320.5,323.25,326.0,328.76,331.51,334.26,337.01,339.76,342.51,345.26,348.01,350.76,353.52,356.27,359.02,361.77,364.52,367.27,370.02,372.77,375.52,378.28,381.03,383.78,386.53,389.28,563.97,566.72,569.48,572.23,574.98,577.73,580.48,583.23,585.98,588.73,591.48,594.24,596.99,599.74,602.49,605.24,607.99,610.74,613.49,616.24,619.0],"fuelHour":0},{"points":[69.1,80.88,92.66,104.44,116.23,128.01,139.79,151.57,163.36,249.65,261.43,273.2,284.98,296.77,308.55,320.33,332.11,343.9,355.68,470.63,482.41,494.19,505.97,517.76,529.54,541.32,553.1,564.89,576.67,1178.78,1190.56,1202.34,1214.13,1225.91,1237.69,1249.47,1261.26,1273.04,1284.82,1551.07,1562.85,1574.63,1586.42,1598.2,1609.98,1621.76,1633.55,1645.33,1657.11,2029.96,2041.75,2053.53,2065.31,2077.09,2088.88,2100.66,2112.44,2124.22,2136.01,2738.12,2749.9,2761.68,2773.46,2785.25,2797.03,2808.81,2820.59,2832.38,2844.16,2930.44,2942.22,2954.0,2965.79,2977.57,3018.01,3029.79,3041.57,3053.36,3065.14,3331.4,3343.18,3354.96,3366.74,3378.53,3390.31,3402.09,3413.87,3425.66,3437.44,4039.54,4051.32,4063.1,4074.89,4086.67,4098.45,4167.55,4437.24,4477.68,4489.47,6925.6],"fuelHour":16.3685},{"points":[19.39,38.79,58.18,77.58,96.97,116.36,135.76,155.15,174.54,423.19,442.58,461.97,481.37,500.76,577.47,1170.01,1189.4,1208.79,1228.19,1505.49,1524.88,1544.27,1563.67,1583.06,1602.45,1621.85,1641.24,1660.64,1680.03,1986.0,2005.39,2597.92,2617.31,2636.7,2656.1,2675.49,2694.89,2714.28,2733.67,5741.4,5760.79,5780.19,5799.58,5818.98,5895.68,5915.08,5934.47,6527.0,6546.39,7081.61,7101.0,7120.39,7139.79,7159.18,7178.57,7197.97,7217.36,7236.76,7256.15,8135.25,8154.64,8174.04,8193.43,8785.96,8805.35,8824.75,8844.14,8863.53,8882.93,9131.58,9150.97,9170.37,9189.76,9209.15,9314.52,9333.91,9353.31,9372.7,9392.09,12684.67,12702.35,12720.02,12737.7,12755.37,12773.05,12790.72,12808.39,12826.07,12843.74,13147.98,13165.65,13183.33,13201.0,13218.68,13236.35,13827.16,13844.83,13862.51,13880.18,14986.82],"fuelHour":16.3682}];

    function setup($root) {
      if ($root.data('cc2Init')) return;
      $root.data('cc2Init', true);

      var cfg;
      try { cfg = JSON.parse($root.find('[data-cc2-json]').text()); } catch (e) { return; }
      if (!cfg.bikes || !cfg.bikes.length) return;

      var defaultFuel = num(cfg.fuelDefault);
      var N = 0; // number of hours on the chart
      cfg.bikes.forEach(function (b, bi) {
        b.points = parsePoints(b.points);
        b.fuelHour = num(b.fuelHour);
        if (!b.points && cfg.builtIn !== false && BUILTIN[bi]) {
          b.points = BUILTIN[bi].points.slice();
          b.fuelHour = BUILTIN[bi].fuelHour;
        }
        b.lph = num(b.lph);
        b.other = num(b.other);
        b.schedule = parseSchedule(b.maintenance);
        if (b.points) N = Math.max(N, b.points.length);
      });
      if (!N) N = Math.max(1, parseInt(cfg.maxHours, 10) || 100);

      var $fuel = $root.find('[data-cc2-fuel]');
      var $hours = $root.find('[data-cc2-hours]');
      var $sub = $root.find('[data-cc2-sub]');
      var $rows = $root.find('[data-cc2-row]');
      var $chart = $root.find('[data-cc2-chart]');
      var $tip = $root.find('[data-cc2-tooltip]');
      var currency = cfg.currency || '$';
      var locale = cfg.locale || 'en-US';
      var firstDraw = true;
      var shown = cfg.bikes.map(function () { return 0; });
      var series = [];   // current data per bike (length N)
      var geom = null;   // chart geometry for tooltip

      function money(v) {
        return currency + v.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }

      // ---------- data ----------
      function seriesFor(b, price) {
        var out = [], i;
        if (b.points) {
          var extra = b.fuelHour * (defaultFuel > 0 ? price / defaultFuel : 1) - b.fuelHour;
          for (i = 0; i < N; i++) {
            var v = b.points[Math.min(i, b.points.length - 1)];
            out.push(v + extra * (i + 1));
          }
        } else {
          for (i = 1; i <= N; i++) {
            var c = i * (b.lph * price + b.other);
            b.schedule.forEach(function (s) { c += Math.floor(i / s.every + 1e-9) * s.cost; });
            out.push(c);
          }
        }
        return out;
      }

      // ---------- left card ----------
      function tween($el, from, to) {
        var start = null, dur = 500;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var e = 1 - Math.pow(1 - p, 3);
          $el.html('<strong>' + money(from + (to - from) * e) + '</strong>');
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }

      // ---------- chart ----------
      function isMobile() { return window.innerWidth < 768; }

      function drawChart() {
        var mobile = isMobile();
        var W = 355, H = 193.5;
        var pad = mobile
          ? { top: 0.05 * H, right: 0.06 * W, bottom: 0.2 * H, left: 0.06 * W }
          : { top: 24, right: 32, bottom: 0.16 * H, left: 32 };
        var cw = W - pad.left - pad.right;
        var ch = H - pad.top - pad.bottom;

        var all = [].concat.apply([], series);
        var dMin = Math.min.apply(null, all), dMax = Math.max.apply(null, all), range = dMax - dMin;
        var yMin = Math.max(0, dMin - 0.1 * range), yMax = dMax + 0.1 * range;
        if (yMax <= yMin) yMax = yMin + 1;
        var ticks = mobile ? 4 : 6;

        function X(i) { return pad.left + (N > 1 ? i / (N - 1) : 0) * cw; }
        function Y(v) { return pad.top + ch - (v - yMin) / (yMax - yMin) * ch; }

        var svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, 'class': 'cc2__svg', role: 'img', 'aria-label': cfg.chartLabel || 'Cost chart' });

        for (var t = 0; t < ticks; t++) {
          var val = yMin + (yMax - yMin) / (ticks - 1) * t;
          var y = Y(val);
          svg.appendChild(el('line', { x1: pad.left, y1: y, x2: pad.left + cw, y2: y, 'class': 'cc2__gridline' }));
          var a = el('text', { x: pad.left - 10, y: y + 4, 'text-anchor': 'end', 'class': 'cc2__axis' }); a.textContent = kLabel(val);
          var b = el('text', { x: pad.left + cw + 10, y: y + 4, 'text-anchor': 'start', 'class': 'cc2__axis' }); b.textContent = kLabel(val);
          svg.appendChild(a); svg.appendChild(b);
        }

        var every = mobile ? 20 : 10;
        if (N / every > 10) every = Math.ceil(N / 10 / every) * every; // avoid crowded labels
        for (var h = 0; h < N; h += every) {
          var tx = el('text', { x: X(h), y: pad.top + ch + (mobile ? 15 : 20), 'text-anchor': 'middle', 'class': 'cc2__axis' });
          tx.textContent = h + 1;
          svg.appendChild(tx);
        }

        // Stark order: VARG first, then the others (VARG drawn underneath like the original)
        var paths = [];
        cfg.bikes.forEach(function (bike, bi) {
          var pts = series[bi].map(function (v, i) { return { x: X(i), y: Y(v) }; });
          var tension = 0.4;
          var d = 'M ' + pts[0].x + ' ' + pts[0].y;
          for (var i = 1; i < pts.length; i++) {
            var p0 = pts[i - 1], p1 = pts[i];
            if (pts[i + 1]) {
              var cx = p0.x + (p1.x - p0.x) * tension, cy = p0.y + (p1.y - p0.y) * tension;
              d += ' Q ' + cx + ' ' + cy + ' ' + p1.x + ' ' + p1.y;
            } else {
              d += ' L ' + p1.x + ' ' + p1.y;
            }
          }
          var path = el('path', { d: d, 'class': 'cc2__line', stroke: bike.color, 'stroke-width': bike.width, fill: 'none' });
          svg.appendChild(path);
          paths.push(path);
        });

        // hover line
        var hover = el('line', { x1: 0, y1: pad.top, x2: 0, y2: pad.top + ch, 'class': 'cc2__hoverline' });
        svg.appendChild(hover);

        $chart.find('svg').remove();
        $chart.find('.cc2__legend').length ? $chart.find('.cc2__legend').before(svg) : $chart.append(svg);
        geom = { W: W, pad: pad, cw: cw, ch: ch, svg: svg, hover: hover };

        if (firstDraw) {
          paths.forEach(function (p) {
            var len = p.getTotalLength();
            p.style.strokeDasharray = len;
            p.style.setProperty('--len', len);
            p.classList.add('is-draw');
          });
        }
      }

      // Tooltip (hour + value of every bike), like the original chart
      $chart.on('mousemove', 'svg', function (e) {
        if (!geom) return;
        var r = this.getBoundingClientRect();
        var scale = r.width / geom.W;
        var sx = (e.clientX - r.left) / scale - geom.pad.left;
        var sy = (e.clientY - r.top) / scale - geom.pad.top;
        if (sx < 0 || sx > geom.cw || sy < 0 || sy > geom.ch) { hideTip(); return; }
        var i = Math.max(0, Math.min(N - 1, Math.round(sx / geom.cw * (N - 1))));
        var html = '<div class="cc2__tt-label">' + (i + 1) + '</div>';
        cfg.bikes.forEach(function (b, bi) {
          html += '<div class="cc2__tt-item"><span class="cc2__tt-color" style="background:' + b.color + '"></span>' +
            $('<i>').text(b.name).html() + ': ' + kLabel(series[bi][i]) + '</div>';
        });
        var cr = $chart[0].getBoundingClientRect();
        $tip.html(html).css({ left: e.clientX - cr.left, top: e.clientY - cr.top }).addClass('is-visible');
        var hx = geom.pad.left + (N > 1 ? i / (N - 1) : 0) * geom.cw;
        geom.hover.setAttribute('x1', hx); geom.hover.setAttribute('x2', hx);
        geom.hover.classList.add('is-visible');
      });
      function hideTip() {
        $tip.removeClass('is-visible');
        if (geom) geom.hover.classList.remove('is-visible');
      }
      $chart.on('mouseleave', hideTip);

      // ---------- update ----------
      function price() {
        var p = parseFloat($fuel.val());
        return isNaN(p) ? defaultFuel : p;
      }
      function hours() {
        var h = parseInt($hours.val(), 10);
        return Math.max(1, Math.min(N, isNaN(h) ? N : h));
      }

      function update() {
        var P = price(), Hh = hours();
        series = cfg.bikes.map(function (b) { return seriesFor(b, P); });

        var totals = series.map(function (s) { return Math.round(s[Hh - 1] || 0); });
        var max = Math.max.apply(null, totals.concat([1]));

        $sub.text((cfg.subText || 'Over [hours] hours of usage').replace('[hours]', Hh));

        $rows.each(function (i) {
          var $r = $(this);
          var pct = Math.min(100, Math.max(0, Math.round(totals[i] / max * 100)));
          $r.find('.cc2__bar').css('width', pct + '%');
          tween($r.find('.cc2__value'), shown[i], totals[i]);
          shown[i] = totals[i];
        });

        drawChart();
        firstDraw = false;
      }

      // ---------- inputs ----------
      function fit() {
        var e = $fuel[0];
        if (e) e.style.width = (Math.max(1, e.value.length) + 0.4) + 'ch';
      }

      // Fuel: digits fill from the right ("5","0","0" → 0.05 → 0.50 → 5.00), like the original
      $fuel.on('keydown', function (e) {
        if (e.ctrlKey || e.metaKey || ['ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'].indexOf(e.key) > -1) return;
        if (e.key === 'Enter') { this.blur(); return; }
        var cents = Math.round(100 * (parseFloat(this.value) || 0));
        if (e.key === 'Backspace' || e.key === 'Delete') {
          e.preventDefault();
          this.value = (Math.floor(cents / 10) / 100).toFixed(2);
        } else if (/^\d$/.test(e.key)) {
          e.preventDefault();
          this.value = ((10 * cents + parseInt(e.key, 10)) / 100).toFixed(2);
        } else if (e.key === 'Unidentified' || e.key === 'Process') {
          return; // some mobile keyboards — handled by the input event
        } else {
          e.preventDefault();
          return;
        }
        fit(); queue();
      });
      // paste / mobile keyboards
      $fuel.on('input', function () {
        var digits = this.value.replace(/\D/g, '');
        this.value = digits === '' ? '' : (parseInt(digits, 10) / 100).toFixed(2);
        fit(); queue();
      });
      $fuel.on('blur', function () {
        var v = parseFloat(this.value);
        this.value = (isNaN(v) ? defaultFuel : Math.max(0, v)).toFixed(2);
        fit(); update();
      });

      // Hours: digits only, clamp on blur
      $hours.on('keydown', function (e) {
        if (e.ctrlKey || e.metaKey || ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'].indexOf(e.key) > -1) return;
        if (e.key === 'Enter') { this.blur(); return; }
        if (e.key === 'Unidentified' || e.key === 'Process') return;
        if (!/^\d$/.test(e.key)) e.preventDefault();
      });
      $hours.on('input', function () { this.value = this.value.replace(/\D/g, ''); queue(); });
      $hours.on('blur', function () { this.value = hours(); update(); });

      var timer;
      function queue() { clearTimeout(timer); timer = setTimeout(update, 200); }

      $root.find('[data-cc2-reset]').on('click', function (e) {
        e.preventDefault();
        var $btn = $(this);
        var $input = $btn.closest('.cc2__field').find('input');
        if ($input.is($fuel)) $input.val(defaultFuel.toFixed(2)); else $input.val($input.data('default'));
        fit();
        $btn.addClass('is-spin');
        setTimeout(function () { $btn.removeClass('is-spin'); }, 400);
        update();
      });

      $fuel.val(defaultFuel.toFixed(2));
      fit();

      var resizeT;
      $(window).on('resize', function () {
        clearTimeout(resizeT);
        resizeT = setTimeout(function () { if (series.length) drawChart(); }, 150);
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { update(); io.disconnect(); }
        }, { threshold: 0.2 });
        io.observe($root[0]);
      } else {
        update();
      }
    }

    $(function () { $('[data-cc2]').each(function () { setup($(this)); }); });
    $(document).on('shopify:section:load', function (e) {
      $(e.target).find('[data-cc2]').each(function () { setup($(this)); });
    });
  }

  if (window.jQuery) {
    init(window.jQuery);
  } else {
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js';
    s.onload = function () { init(window.jQuery); };
    document.head.appendChild(s);
  }
})();